import {Signal} from "../Core/Signal";
import {Callback} from "../Core/Reflection";
import * as HLF from "html-living-framework";

export class PubSubEvent {
    static readonly voiceOverStarted = Signal<Callback>();
    static readonly voiceOverEnded = Signal<Callback>();
}

PubSub.subscribe(HLF.VOICEOVER_STARTED, PubSubEvent.voiceOverStarted);
PubSub.subscribe(HLF.VOICEOVER_ENDED, PubSubEvent.voiceOverEnded);